import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import ExamTimer from './ExamTimer';

const MODULE_INTRO = {
  lesen: (
    <>
      Das Modul Lesen hat fünf Teile. Sie lesen mehrere Texte und lösen Aufgaben dazu.
      Für jede Aufgabe gibt es nur eine richtige Lösung. Wörterbücher und Mobiltelefone sind nicht erlaubt.
    </>
  ),
  hoeren: (
    <>
      Das Modul Hören hat vier Teile. Sie hören mehrere Texte und lösen Aufgaben dazu.
      Lesen Sie jeweils zuerst die Aufgaben und hören Sie dann den Text dazu.
      Für jede Aufgabe gibt es nur eine richtige Lösung.
    </>
  ),
  schreiben: (
    <>
      Das Modul Schreiben hat zwei Teile. In Teil 1 schreiben Sie einen Forumsbeitrag.
      In Teil 2 schreiben Sie eine Nachricht. Schreiben Sie deutlich. Wörterbücher sind nicht erlaubt.
    </>
  ),
};

const ExamPaperLayout = ({
  moduleKey,
  moduleName,
  moduleDuration,
  totalMinutes,
  timerRunning,
  onExit,
  children,
}) => (
  <div className="exam-paper-root">
    <div className="exam-paper">
      <header className="exam-paper-header">
        <div className="flex justify-between items-start gap-4">
          <div>
            <p className="exam-paper-brand">Goethe-Zertifikat B2</p>
            <p className="exam-paper-subbrand">Kandidatenblätter · Modellsatz Erwachsene</p>
            <h1 className="exam-paper-module-title">
              {moduleName}{' '}
              <span className="font-normal text-base text-brand-text/80">{moduleDuration}</span>
            </h1>
          </div>
          <div className="flex flex-col items-end gap-2 shrink-0">
            {totalMinutes != null && (
              <ExamTimer
                totalMinutes={totalMinutes}
                isRunning={timerRunning}
                label="Zeit"
                variant="pdf"
              />
            )}
            {onExit && (
              <button
                type="button"
                onClick={onExit}
                className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-brand-text/70 hover:text-black font-sans"
              >
                <ArrowLeftIcon className="w-3.5 h-3.5" />
                Zurück
              </button>
            )}
          </div>
        </div>
      </header>
      <div className="exam-paper-body">
        {MODULE_INTRO[moduleKey] && (
          <p className="exam-module-intro">{MODULE_INTRO[moduleKey]}</p>
        )}
        {children}
      </div>
    </div>
  </div>
);

export default ExamPaperLayout;
